import {createAction} from '@reduxjs/toolkit'

export const setOfferCheckOverrideUrl = createAction<string | undefined>(
  'common/setOfferCheckOverrideUrl'
)

export const clearOfferCheckOverrideUrl = createAction(
  'common/clearOfferCheckOverrideUrl'
)

export type ActionType =
  | ReturnType<typeof setOfferCheckOverrideUrl>
  | ReturnType<typeof clearOfferCheckOverrideUrl>
